import ConfigData from 'config/ConfigData';
import getAppSite from 'utils/getAppSite';

const TweetsFilters = ConfigData?.analyticsTweetFilters;
let graphDataSections = [
  {
    name: 'Spoken parliamentary contributions',
    type: 'ParliamentaryRecord',
    field: 'contentType',
    value: 'ParliamentaryContribution',
  },
  {
    name: 'Written questions',
    type: 'WrittenQuestion',
    field: 'contentType',
    value: '',
  },
  {
    name: 'Written questions (Wales)',
    type: 'CountrySpecificWrittenQuestion',
    field: 'country',
    value: 'Wales',
    additionalFilters: [{ field: 'country', value: 'Wales', operator: 'str_eq' }],
  },
  {
    name: 'Written questions (Scotland)',
    type: 'CountrySpecificWrittenQuestion',
    field: 'country',
    value: 'Scotland',
    additionalFilters: [{ field: 'country', value: 'Scotland', operator: 'str_eq' }],
  },
  {
    name: 'EDMs',
    type: 'ParliamentaryRecord',
    field: 'contentType',
    value: 'Edm',
  },
  {
    name: 'Committee contributions',
    type: 'ParliamentaryRecord',
    field: 'contentType',
    value: 'SeneddCommitteeTranscriptContribution',
  },
];

if (getAppSite() === 'usa') {
  graphDataSections = [
    {
      name: 'Congressional records',
      type: 'ParliamentaryRecord',
      field: 'contentType',
      value: 'CREC',
    },
  ];
}

if (import.meta.env.VITE_APP_ENABLE_TWITTER === 'true') {
  graphDataSections = [
    ...graphDataSections,
    {
      name: 'Tweets',
      type: 'Tweet',
      field: 'isRetweet',
      value: 'false',
      additionalFilters: TweetsFilters,
    },
    {
      name: 'Retweets',
      type: 'Tweet',
      field: 'isRetweet',
      value: 'true',
      additionalFilters: TweetsFilters,
    },
  ];
}

export default graphDataSections;
